module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', {
    staticClass: "moduleWrapper"
  }, [_c('md-card-content', {
    staticClass: "module"
  }, [_c('md-card', {
    staticClass: "card moduleTwo moduleSeven",
    class: {
      dark: _vm.slides[_vm.slidePosition].isDark, layoutTwo: _vm.slides[_vm.slidePosition].layout2, layoutThree: _vm.slides[_vm.slidePosition].layout3, layoutFour: _vm.slides[_vm.slidePosition].layout4, layoutFive: _vm.slides[_vm.slidePosition].layout5, listLeft: _vm.slides[_vm.slidePosition].listLeft, tourQuiz: _vm.slides[_vm.slidePosition].tourQuiz, listsText: _vm.slides[_vm.slidePosition].listsText, modeStart: _vm.slides[_vm.slidePosition].modeStart, cert: _vm.slides[_vm.slidePosition].cert, thanks: _vm.slides[_vm.slidePosition].thanks, tourSlide: _vm.slides[_vm.slidePosition].tour || _vm.slides[_vm.slidePosition].device
    },
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.slides[_vm.slidePosition].fadeImg) ? _c('img', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "device",
    attrs: {
      "src": _vm.slides[_vm.slidePosition].fadeImg,
      "alt": "Body Guard"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].quiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "quiz"
  }, [_c('h4', [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].question))]), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswerOne) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(1)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(2)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-radio', {
    attrs: {
      "id": "answer3",
      "name": "group1",
      "md-value": "3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(3)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[3]) ? _c('md-radio', {
    attrs: {
      "id": "answer4",
      "name": "group1",
      "md-value": "4"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(4)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[3].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Question 1 of 5")])], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].multiAnswer) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer1",
      "value": "right"
    },
    model: {
      value: (_vm.answer5),
      callback: function($$v) {
        _vm.answer5 = $$v
      },
      expression: "answer5"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer2",
      "value": "right"
    },
    model: {
      value: (_vm.answer6),
      callback: function($$v) {
        _vm.answer6 = $$v
      },
      expression: "answer6"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer3",
      "value": "right"
    },
    model: {
      value: (_vm.answer7),
      callback: function($$v) {
        _vm.answer7 = $$v
      },
      expression: "answer7"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.testMulti()
      }
    }
  }, [_vm._v("Check Answer")]), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Question 2 of 5")])], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswerTwo) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(1)
      }
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(2)
      }
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-radio', {
    attrs: {
      "id": "answer3",
      "name": "group1",
      "md-value": "3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(3)
      }
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[3]) ? _c('md-radio', {
    attrs: {
      "id": "answer4",
      "name": "group1",
      "md-value": "4"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(4)
      }
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[3].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Question 3 of 5")])], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswerThree) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(1)
      }
    },
    model: {
      value: (_vm.answer3),
      callback: function($$v) {
        _vm.answer3 = $$v
      },
      expression: "answer3"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(2)
      }
    },
    model: {
      value: (_vm.answer3),
      callback: function($$v) {
        _vm.answer3 = $$v
      },
      expression: "answer3"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-radio', {
    attrs: {
      "id": "answer3",
      "name": "group1",
      "md-value": "3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(3)
      }
    },
    model: {
      value: (_vm.answer3),
      callback: function($$v) {
        _vm.answer3 = $$v
      },
      expression: "answer3"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[3]) ? _c('md-radio', {
    attrs: {
      "id": "answer4",
      "name": "group1",
      "md-value": "4"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(4)
      }
    },
    model: {
      value: (_vm.answer3),
      callback: function($$v) {
        _vm.answer3 = $$v
      },
      expression: "answer3"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[3].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Question 4 of 5")])], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswerFour) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(1)
      }
    },
    model: {
      value: (_vm.answer4),
      callback: function($$v) {
        _vm.answer4 = $$v
      },
      expression: "answer4"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(2)
      }
    },
    model: {
      value: (_vm.answer4),
      callback: function($$v) {
        _vm.answer4 = $$v
      },
      expression: "answer4"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-radio', {
    attrs: {
      "id": "answer3",
      "name": "group1",
      "md-value": "3"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(3)
      }
    },
    model: {
      value: (_vm.answer4),
      callback: function($$v) {
        _vm.answer4 = $$v
      },
      expression: "answer4"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[3]) ? _c('md-radio', {
    attrs: {
      "id": "answer4",
      "name": "group1",
      "md-value": "4"
    },
    nativeOn: {
      "click": function($event) {
        _vm.test(4)
      }
    },
    model: {
      value: (_vm.answer4),
      callback: function($$v) {
        _vm.answer4 = $$v
      },
      expression: "answer4"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[3].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Question 5 of 5")])], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct || _vm.slides[_vm.slidePosition].incorrect) ? _c('p', [_vm._v("Your current score is " + _vm._s(_vm.score))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.slides[_vm.slidePosition].modes) ? _c('md-list', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "nav"
  }, [_c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-1"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/1.svg"),
      "alt": "Module 1"
    }
  })]), _c('p', [_vm._v("Module 1")]), _c('span', [_vm._v("Features")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(2)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-2"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/2.svg"),
      "alt": "Module 2"
    }
  })]), _c('p', [_vm._v("Module 2")]), _c('span', [_vm._v("Modes of operation")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(3)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-3"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/3.svg"),
      "alt": "Module 3"
    }
  })]), _c('p', [_vm._v("Module 3")]), _c('span', [_vm._v("Alarms & Trouble Shooting")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(4)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-4"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/4.svg"),
      "alt": "Module 4"
    }
  })]), _c('p', [_vm._v("Module 4")]), _c('span', [_vm._v("Care & Maintenance")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(5)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-5"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/5.svg"),
      "alt": "Module 5"
    }
  })]), _c('p', [_vm._v("Module 5")]), _c('span', [_vm._v("Accessories")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(6)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-6"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/6.svg"),
      "alt": "Module 1"
    }
  })]), _c('p', [_vm._v("Module 6")]), _c('span', [_vm._v("Additional Features")])])], 1)]), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.moduleSelected(7)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-7"
    }
  }, [_c('div', {
    staticClass: "imgWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/7.svg"),
      "alt": "Module 7"
    }
  })]), _c('p', [_vm._v("Module 7")]), _c('span', [_vm._v("Course Summary & Assessment")])])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].lines), function(line) {
    return _c('p', {
      key: _vm.slides[_vm.slidePosition].id,
      class: {
        bold: line.b, orange: line.o, start: line.s
      }
    }, [_vm._v(_vm._s(line.text))])
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].linkHref) ? _c('a', {
    key: _vm.slides[_vm.slidePosition].id,
    attrs: {
      "href": _vm.slides[_vm.slidePosition].linkHref,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].linkText))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].img) ? _c('img', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "device",
    attrs: {
      "src": _vm.slides[_vm.slidePosition].img,
      "alt": "Body Guard"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].img2) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "shiftWrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.slides[_vm.slidePosition].img2,
      "alt": "Body Guard"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].button) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "btnWrap"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.startTest($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].button) + " ")]), _vm._v(" "), (_vm.score >= 80) ? _c('md-button', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "md-icon-button certJump",
    nativeOn: {
      "click": function($event) {
        _vm.jumpTo(7)
      }
    }
  }, [_vm._v("Get Certificate")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].results) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "results"
  }, [_c('p', [_vm._v("Your score: " + _vm._s(_vm.score) + "%")]), _vm._v(" "), _c('p', [_vm._v("Recommended score: 80%")]), _vm._v(" "), _c('p', [_vm._v("Result: "), (_vm.score >= 80) ? _c('span', [_vm._v("Pass!")]) : _c('span', [_vm._v("Fail")])]), _vm._v(" "), _c('p', [_vm._v("You can either re-try the quiz to improve your score or if you have passed continue to receive your certificate")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.resetTest($event)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/module-7"
    }
  }, [_vm._v("Retry")])], 1), _vm._v(" "), (_vm.score >= 80) ? _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.incrementPosition(_vm.slidePosition)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].cert) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "results"
  }, [_c('p', [_vm._v("Thank you for completing this course. This course has given you a basis to understand how the BodyGuard 323 Color Vision works but further competences need to be developed by use and experience. It’s important you continue to develop your current level of competence. You can review any aspect of the pump by referring to this course content list.")]), _vm._v(" "), _c('md-button', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "md-primary md-raised modal",
    attrs: {
      "id": "modal"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('pop')
      }
    }
  }, [_vm._v("Get Your Certificate")]), _vm._v(" "), (_vm.slides[_vm.slidePosition].modal) ? _c('md-dialog', {
    key: _vm.slides[_vm.slidePosition].id,
    ref: "pop",
    staticClass: "certificate",
    attrs: {
      "md-open-from": "#modal",
      "md-close-to": "#modal"
    }
  }, [_c('md-dialog-content', [_c('md-button', {
    staticClass: "md-primary close",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('pop')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-button md-raised print",
    nativeOn: {
      "click": function($event) {
        _vm.print($event)
      }
    }
  }, [_vm._v("Print Your Certificate")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "print"
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("../assets/certificate.jpg"),
      "alt": "certificate"
    }
  })])], 1)], 1) : _vm._e()], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "slideWrap"
  }, [_c('md-progress', {
    attrs: {
      "md-progress": _vm.progressPercent
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "progText"
  }, [_vm._v("Progress "), _c('b', [_vm._v(_vm._s(Math.trunc(_vm.progressPercent)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "progNav"
  }, [_c('router-link', {
    attrs: {
      "to": "/front"
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("../assets/home.svg"),
      "alt": "Front Page"
    }
  })]), _vm._v(" "), (_vm.notFirstSlide) ? _c('div', [(_vm.moduleEnd) ? _c('div', {
    staticClass: "imgWrap next"
  }, [_c('router-link', {
    attrs: {
      "to": "/front"
    },
    nativeOn: {
      "click": function($event) {
        _vm.moduleComplete(7, 0)
      }
    }
  }, [_c('p', [_vm._v("Next")]), _c('img', {
    attrs: {
      "src": require("../assets/arrow-right-thick.svg"),
      "alt": "Next"
    }
  })])], 1) : _vm._e()]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df83fd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Module7.vue
// module id = 757
// module chunks = 0